import React, { useState } from 'react';
import { X, Lock, Loader2, Check } from 'lucide-react';
import { toast } from 'sonner';
import { AuthAPI, errText } from '../api';

export default function AccountModal({ user, onClose }) {
  const [cur, setCur] = useState('');
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { toast.error('New passwords don\u2019t match.'); return; }
    setBusy(true);
    try {
      await AuthAPI.changePassword(cur, pw);
      toast.success('Password changed.');
      onClose();
    } catch (err) { toast.error(errText(err, 'Could not change your password.')); }
    finally { setBusy(false); }
  };

  const input = 'w-full rounded-xl border hairline bg-panel2/50 px-4 py-3 text-cream placeholder:text-cream/35 outline-none focus:border-gold/50 transition-colors';
  return (
    <div className="fixed inset-0 z-50 grid place-items-center px-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} />
      <div className="relative panel rounded-3xl p-7 w-full max-w-md" data-testid="account-modal">
        <div className="flex items-start justify-between mb-6">
          <div><p className="eyebrow text-[9px] mb-1">Account</p><h2 className="font-display text-3xl text-cream">Your account.</h2></div>
          <button onClick={onClose} data-testid="account-close" className="grid place-items-center w-9 h-9 rounded-full border hairline text-cream/60 hover:text-cream"><X size={16} /></button>
        </div>
        <div className="rounded-2xl border hairline p-4 text-sm space-y-1 mb-6">
          <p className="text-cream/50">Signed in as</p>
          <p className="text-cream" data-testid="account-email">{user.email}</p>
          <p className="text-cream/50 pt-2">Business</p>
          <p className="text-cream">{user.business_name}</p>
        </div>
        {user.temp_password && <p className="text-xs text-gold mb-4 flex items-center gap-2"><Lock size={12} /> You&rsquo;re using the temporary password Perry sent. Choose your own below.</p>}
        <form onSubmit={submit} className="space-y-3" data-testid="change-password-form">
          <input type="password" required placeholder="Current password" value={cur} onChange={(e) => setCur(e.target.value)} data-testid="current-password" className={input} />
          <input type="password" required minLength={8} placeholder="New password (8+ characters)" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="new-password" className={input} />
          <input type="password" required minLength={8} placeholder="Repeat new password" value={pw2} onChange={(e) => setPw2(e.target.value)} data-testid="new-password-2" className={input} />
          <button type="submit" disabled={busy} data-testid="change-password-submit" className="w-full btn-gold rounded-full py-3.5 flex items-center justify-center gap-2 disabled:opacity-70">{busy ? <Loader2 size={16} className="animate-spin" /> : <><Check size={16} /> Change password</>}</button>
        </form>
      </div>
    </div>
  );
}
